import React, { useEffect, useState } from "react";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaUser,
  FaClock,
} from "react-icons/fa";
import Modal from "../modal/Modal";
import BookSessionForm from "../forms/BookSessionForm";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../services/mentorProfile";
import dummyImage from "../../images/background/banner.jpg";
import Skeleton from "react-loading-skeleton";

const Tag = ({ label }) => (
  <span className="bg-blue-50 text-purple-700 text-sm px-3 py-1 border border-purple-300 rounded-md">
    {label}
  </span>
);

const QuickStat = ({ icon: Icon, label }) => (
  <div className="flex items-center gap-2 text-gray-800 text-sm">
    <Icon /> {label}
  </div>
);

function humanizeExperience(text) {
  if (typeof text !== "string") return "";

  let result = text.replace(/_plus_/g, "+ ");
  result = result.replace(/(\d)_(\d)/g, "$1-$2");
  result = result.replace(/_/g, " ");
  result = result.replace(/(?<!\d)-(?!\d)/g, " ");
  result = result.replace(/\b\w/g, (char) => char.toUpperCase());
  result = result.replace(/\byears\b/gi, "Years");
  result = result.replace(/\bexperience\b/gi, "Experience");

  return result;
}

const MentorProfile = () => {
  const { userId } = useParams();
  const dispatch = useDispatch();
  const mentorProfile = useSelector((state) => state.mentor.profile);
  const [review, setReview] = useState(null);
  const [userData, setUserData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const userType = localStorage.getItem("userType")

  useEffect(() => {
    dispatch(getProfile({ userId })).then((data) => {
      setUserData(data);
      // fetch review
    });
  }, [dispatch, userId]);
  

  const rating = Math.round(review?.averageRating || 0);
  const reviewsCount = review?.count || 0;

  if (!userData) return <Skeleton count={5} />;
    function toHumanReadable(str) {
    return str
        .split('_')                     
        .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
        .join(' ');                   
    }

    const skills = [
        ...(userData?.general || []),
        ...(userData?.AILiteracySkills || []),
        ...(userData?.appliedAISkills || []),
        ...(userData?.ethicsResponsibleAI || []),
        ...(userData?.softAISkills || []),
        ...(userData?.strategicAISkills || []),
        ...(userData?.technicalAISkills || []),
        ...(userData?.TechnicalDevelopmentRoles || []),
        ...(userData?.InfrastureRoles || []),
        ...(userData?.ethicsRoles || []),
        ...(userData?.buisnessRole || []),
        ...(userData?.CreativeRole || []),
        ...(userData?.Compliance || []),
        ...(userData?.EmergingAI || []),
        ...(userData?.MachineLearningDeepLearningPlatforms || []),
        ...(userData?.AutoMLNoCodeLowCodeAIPlatforms || []),
        ...(userData?.NaturalLanguageProcessingTools || []),
        ...(userData?.ComputerVisionTools || []),
        ...(userData?.GenerativeAITools || []),
        ...(userData?.MLOpsDeploymentTools || []),
        ...(userData?.DataScienceVisualizationTools || []),
        ...(userData?.CommunicationSkills || []),
        ...(userData?.InterpersonalTeamworkSkills || []),
        ...(userData?.CriticalThinkingProblemSolving || []),
        ...(userData?.LeadershipInfluence || []),
        ...(userData?.ai_application || []),
    ];

    const humanReadableSkills = skills.map(toHumanReadable);

    const prices = ["15minmeeting", "30minmeeting", "45minmeeting", "60minmeeting"];
    const hasAnyPrice = prices.some(
      (key) => userData?.mentorMeeting?.[key] !== undefined && userData?.mentorMeeting?.[key] !== null
    );

  return (
    <div className="bg-gray-100 min-h-screen p-6">
      {/* Banner & Header */}
      <div className="bg-white rounded-xl overflow-hidden shadow">
        <div className="h-40 bg-gray-200">
          <img
            src={userData.bannerImage || dummyImage}
            alt="Banner"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="p-6 -mt-16">
        <div className="flex flex-col ">
          <img
            src={userData.profileImage || dummyImage}
            alt="Avatar"
            className="w-28 h-28 rounded-full border-4 border-white object-cover"
          />

          <div className="mt-4 w-full flex flex-col md:flex-row md:items-center md:justify-between text-center md:text-left">
            <div>
              <h2 className="text-2xl font-semibold">
                {userData.firstName} {userData.lastName}
              </h2>
              <p className="text-gray-600">{userData.title}</p>
              <p className="text-sm text-gray-500 flex items-center justify-center md:justify-start gap-1">
                <FaMapMarkerAlt /> {userData.city}, {userData.country}
              </p>
              {/* <div className="flex items-center justify-center md:justify-start gap-1 text-yellow-500 mt-1">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className={i < rating ? "" : "text-gray-300"} />
                ))}
                <span className="text-gray-600 text-sm ml-2">({reviewsCount})</span>
              </div> */}
            </div>

           {userType === "user" && (
              <div className="mt-4 md:mt-0">
                <button
                  className="bg-blue-700 text-white px-4 py-2 rounded-lg"
                  onClick={() => setIsModalOpen(true)}
                >
                  Book Appointment
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      </div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
        {/* Left Column */}
        <div className="md:col-span-2 space-y-6">
          {/* About */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="text-lg font-semibold mb-2">About Me</h3>
            <p className="text-gray-600">{userData.bio}</p>
          </div>

          {/* Skills */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="text-lg font-semibold mb-4">Skills</h3>
            <div className="flex flex-wrap gap-2">
              {humanReadableSkills?.map((s) => (
                <Tag key={s} label={s} />
              ))}
            </div>
          </div>

         {/* Personal Details */}
        <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="text-lg font-semibold mb-4">Personal Details</h3>
            <div className="grid grid-cols-3 text-sm  text-gray-700 tracking-wide">
                <div>Gender</div>
                {/* <div className="ml-5">Date of Birth</div>
                <div>Where Did You Hear About Us</div> */}
            </div>
            <div className="grid grid-cols-3 mt-1 text-sm text-gray-600 font-semibold">
                <div>
                {userData?.gender === 0
                    ? "Male"
                    : userData?.gender === 1
                    ? "Female"
                    : <Skeleton width={80} />}
                </div>
                {/* <div className="font-semibold ml-5" >01-01-1992</div>
                <div className="font-semibold">Through web search</div> */}
            </div>
        </div>
        

          {/* Work Experience */}
        <div className="bg-white p-6 rounded-xl shadow">
          <h3 className="text-lg font-semibold mb-4">Work Experience</h3>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-sm text-gray-700">
            {/* Occupation */}
            <div>
              <div className="text-gray-500">Current Occupation</div>
              <div className="font-semibold text-gray-700">
                {userData?.currentJobOccupation}
              </div>
            </div>

            {/* Professional Experience */}
            <div>
              <div className="text-gray-500">Professional Experience</div>
              <div className="font-semibold text-gray-700">
                {
                  typeof userData?.professionalExperience === "string" ? (
                    userData.professionalExperience
                      .replace(/_/g, " ")
                      .replace(/^./, (c) => c.toUpperCase())
                  ) : (
                    <Skeleton width={80} />
                  )
                }
              </div>
            </div>

            {/* Years of Experience */}
            <div>
              <div className="text-gray-500">Years for Work Experience</div>
              <div className="font-semibold text-gray-700">
                {
                  typeof userData?.yearOfExperience === "string" ? (
                    humanizeExperience(userData.yearOfExperience)
                  ) : (
                    <Skeleton width={80} />
                  )
                }
              </div>
            </div>
          </div>
        </div>

          {/* Pricing */}
          {hasAnyPrice && (
                <div className="bg-white p-6 rounded-xl shadow">
                  <h3 className="text-lg font-semibold mb-4">Pricing</h3>

                  {/* Header row with 4 columns */}
                  <div className="grid grid-cols-4 text-sm text-gray-700 tracking-wide">
                    <div>15 min</div>
                    <div>30 min</div>
                    <div>45 min</div>
                    <div>60 min</div>
                  </div>

                  {/* Values row with prices */}
                  <div className="grid grid-cols-4 mt-1 text-sm text-gray-600 font-semibold">
                    {prices.map((key) => (
                      <div key={key}>
                        {userData?.mentorMeeting?.[key] !== undefined && userData?.mentorMeeting?.[key] !== null
                          ? `$${userData.mentorMeeting[key]}`
                          : "N/A"}
                      </div>
                    ))}
                  </div>
                </div>
              )}
        </div>

        {/* Right Sidebar */}
        <div className="space-y-6">
          {/* Pricing & Contact */}
          <div className="bg-white p-6 rounded-xl shadow">
            <div className="text-xl font-bold text-blue-700 mb-4">
              {userData.mentorMeeting?.["60minmeeting"] && (
                <div className="text-xl font-bold text-blue-700 mb-4">
                  ${userData.mentorMeeting["60minmeeting"]} / Hour
                </div>
              )}
            </div>
            <div className="space-y-3 text-sm text-gray-700">
              <div className="flex items-center gap-2 break-all"><FaEnvelope /> {userData.email}</div>
              <div className="flex items-center gap-2"><FaMapMarkerAlt /> {userData.city}, {userData.country}</div>
              {/* <div className="flex items-center gap-2"><FaPhone /> {userData.phone}</div> */}
              {/* {userData.website && (
                <div className="flex items-center gap-2">
                  <a href={userData.website} target="_blank" className="text-blue-600 underline">
                    {userData.website}
                  </a>
                </div>
              )} */}
            </div>
          </div>

          {/* Quick Stats */}
          <div className="bg-white p-6 rounded-xl shadow">
            <h4 className="font-semibold text-md mb-4">Quick Stats</h4>
            <div className="space-y-3">
              <QuickStat icon={FaUser} label={`${userData.stats?.students || 50} Students`} />
              {/* <QuickStat icon={FaStar} label={`${userData.reviews?.rating || "5.0"} Avg Rating`} /> */}
              <QuickStat
                  icon={FaClock}
                  label={`${
                        typeof userData?.yearOfExperience === "string" ? (
                          humanizeExperience(userData.yearOfExperience)
                        ) : (
                          <Skeleton width={80} />
                        )
                  }`}
                />
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <Modal isOpen onClose={() => setIsModalOpen(false)} label="Book a Session">
          <BookSessionForm
            timeZone={userData.timezone}
            setIsOpen={setIsModalOpen}
            userData={userData}
          />
        </Modal>
      )}
    </div>
  );
};

export default MentorProfile;
